<template>
  <v-app dark>

    <div v-if="AppLoading">
      <h1>Please Wait...</h1>
    </div>

    <div v-show="AppState.loading" id="loading-indicator">
      <v-progress-circular indeterminate :size="60" :width="7" color="red"></v-progress-circular>
    </div>

    <template v-if="!AppLoading">
      <auth-login @showRegistration="showRegistration" v-if="!AppState.Auth.isLogged && !AppState.Auth.showRegister"></auth-login>
      <auth-register v-if="!AppState.Auth.isLogged && AppState.Auth.showRegister" @login="login($event)"></auth-register>

      <template v-if="AppState.Auth.isLogged">
        <div class="sidemenu">
          <v-navigation-drawer app absolute floating clipped v-model="mainMenuOpen">
            <main-menu :menu="menu" @logout="logout" @showMenu="showMenu($event)" @closeClick="closeMainMenu" @backToMenu="backMainMenu"></main-menu>
          </v-navigation-drawer>
        </div>

        <app-header :view="view" @openMenu="openMainMenu" @setView="setView($event)" @openSideMenu="openSideMenu"></app-header>

        <i-frame :class="['main-frame', currentView]">
          <app-main></app-main>
        </i-frame>

        <v-navigation-drawer fixed temporary right v-model="sideMenuOpen" class="menu_bg">
          <side-menu @addBlock="addBlock($event)" @closeClick="closeSideMenu"></side-menu>
        </v-navigation-drawer>
      </template>

      <!--<v-btn fixed fab large bottom right class="red" @click.stop="openSideMenu"> <v-icon>add</v-icon> </v-btn>-->
    </template>

    <v-snackbar v-model="AppState.error.show" :multi-line="true" :vertical="true">
      {{ AppState.error.text }}
      <v-btn flat color="secondary" @click.native="AppState.error.show = false">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import {
  FirebaseAuth,
  FirebaseStorage,
  dbProfile,
  dbProjects,
  dbPages
} from "./firebase";
import AppState from "./util/AppState";
import AuthLogin from "./components/AuthLogin";
import AuthRegister from "./components/AuthRegister";
import Header from "./components/Header";
import Main from "./components/Main";
import SideMenu from "./components/SideMenu";
import MainMenu from "./components/MainMenu";
import bus from "./util/bus";

export default {
  components: {
    "auth-login": AuthLogin,
    "auth-register": AuthRegister,
    "app-header": Header,
    "app-main": Main,
    "side-menu": SideMenu,
    "main-menu": MainMenu
  },
  data() {
    return {
      AppState,
      AppLoading: true,
      mainMenuOpen: false, // left menu open
      sideMenuOpen: false,
      menu: 0,
      view: "desktop"
    };
  },
  computed: {
    currentView() {
      return `is${this.view}`;
    }
  },
  created() {
    FirebaseAuth.onAuthStateChanged(user => {
      this.AppLoading = false;
      if (!AppState.Auth.showRegister) {
        this.login(user);
      }
    });
  },
  methods: {
    openMainMenu() {
      this.mainMenuOpen = true;
      this.menu = 0;
    },
    closeMainMenu() {
      this.mainMenuOpen = false;
    },
    backMainMenu() {
      this.menu = 0;
    },
    setView(newView) {
      this.view = newView;
    },
    openSideMenu() {
      this.sideMenuOpen = true;
    },
    closeSideMenu() {
      this.sideMenuOpen = false;
    },
    showMenu(i) {
      this.menu = i + 1;
    },
    showRegistration() {
      AppState.Auth.showRegister = true;
    },
    login(user) {
      AppState.loading = true;
      if (user) {
        FirebaseStorage.init(user.uid);
        // GET USER PROFILE
        dbProfile
          .doc(user.uid)
          .get()
          .then(profile => {
            AppState.currentProjectID = profile.data().currentProjectID;
            AppState.currentPageID = profile.data().currentPageID;

            // GET USER PROJECTS
            dbProjects
              .where("userID", "==", user.uid)
              .get()
              .then(projects => {
                projects.forEach(doc => {
                  AppState.projects.push({
                    id: doc.id,
                    title: doc.data().title,
                    activePageID: doc.data().activePageID,
                    firebaseConfig: doc.data().firebaseConfig || null,
                    createdAt: doc.data().createdAt,
                    updatedAt: doc.data().updatedAt
                  });
                });
                AppState.projects.sort(
                  (a, b) => (a.createdAt > b.createdAt ? 1 : -1)
                );
                // SET CURRENT PROJECT
                AppState.currentProject = AppState.projects.filter(
                  p => p.id === AppState.currentProjectID
                )[0] || { title: "" };
              })
              .catch(error => {
                AppState.error.text = error;
                AppState.error.show = true;
              });

            // GET USER SELECTED PROJECT'S PAGES
            dbPages
              .where("userID", "==", user.uid)
              .where("projectID", "==", AppState.currentProjectID)
              .get()
              .then(projectPages => {
                projectPages.forEach(doc => {
                  AppState.projectPages.push({
                    id: doc.id,
                    title: doc.data().title,
                    blocks: JSON.parse(doc.data().blocks),
                    loaded: [],
                    loadedDone: [],
                    blockID: doc.data().blockID,
                    createdAt: doc.data().createdAt,
                    updatedAt: doc.data().updatedAt
                  });
                });
                AppState.projectPages.sort(
                  (a, b) => (a.createdAt > b.createdAt ? 1 : -1)
                );
                // SET CURRENT PAGE
                AppState.currentPage = AppState.projectPages.filter(
                  p => p.id === AppState.currentPageID
                )[0] || {
                  title: "",
                  projectID: "",
                  blockID: 0,
                  blocks: [],
                  loaded: [],
                  loadedDone: []
                };
              })
              .catch(error => {
                AppState.error.text = error;
                AppState.error.show = true;
              });

            AppState.Auth.isLogged = true;
            AppState.Auth.showRegister = false;
            AppState.loading = false;
          })
          .catch(error => {
            AppState.error.text = error;
            AppState.error.show = true;
          });
      } else {
        AppState.Auth.isLogged = false;
        AppState.Auth.showRegister = false;
        AppState.loading = false;
      }
    },
    logout() {
      this.menu = 0;
      this.mainMenuOpen = false;
      FirebaseAuth.signOut()
        .then(() => {
          AppState.Auth.isLogged = false;
          AppState.Auth.showRegister = false;
          window.location.reload();
        })
        .catch(error => {
          AppState.error.text = error;
          AppState.error.show = true;
        });
    },
    addBlock(block) {
      AppState.currentPage.blockID += 1;
      const newBlock = JSON.parse(JSON.stringify(block));
      newBlock.blockID = AppState.currentPage.blockID;
      if (block.type === "nav") {
        AppState.currentPage.blocks.unshift(newBlock);
      } else {
        AppState.currentPage.blocks.push(newBlock);
      }
      bus.$emit("addedBlock", newBlock); // , { blockID: newBlock.blockID }
    }
  }
};
</script>

<style lang="stylus">
/* $color-pack = false */
@import '//cdn.jsdelivr.net/npm/medium-editor@5.23.2/dist/css/medium-editor.min.css';
@import '//maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css';
@import './stylus/main';

.text-center {
  text-align: center;
}

.theme--dark .toolbar, .application .theme--dark.toolbar {
  background-color: #424242;
}

.application--dark .navigation-drawer, .application--dark .navigation-drawer .list {
  padding-top: 0;
}

.sidemenu .list li {
  min-height: 2;
}

.list__tile {
  height: 70px;
}

.main-frame {
  display: block;
  width: 100%;
  height: 99vh;
  padding-top: 65px;
  border: 0;
  transition: all 250ms ease-in-out;
}

.main-frame.isMobile {
  width: 422px;
  height: 736px;
  margin: 100px auto 10px auto;
  overflow: auto;
}

.main-frame.isFbTab {
  width: 810px;
  height: 810px;
  margin: 100px auto 10px auto;
  overflow: auto;
}

#loading-indicator {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/App.vue